import { render, staticRenderFns } from "./pogs-users.vue?vue&type=template&id=3d7c2a70&scoped=true&"
import script from "./pogs-users.vue?vue&type=script&lang=js&"
export * from "./pogs-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7c2a70",
  null
  
)

export default component.exports